import React from 'react';
import { Config } from "../../app.config";
import { Alert } from "flowbite-react";
import { HiInformationCircle } from 'react-icons/hi';
var Announce = function Announce() {
  var announce = Config.announce;
  if (announce.enable) {
    return /*#__PURE__*/React.createElement(Alert, {
      color: announce.color,
      icon: HiInformationCircle,
      className: "mb-4"
    }, announce.message);
  } else {
    return null;
  }
};
export default Announce;